import styled from 'styled-components';

const Wrapper = styled.section`
  margin: 2rem 0;
  .colors {
    display: grid;
    grid-template-columns: 75px 0.5fr 75px 0.5fr;
    align-items: center;
    margin-bottom: 1rem;
    span {
      text-transform: capitalize;
      font-weight: 700;
    }
    div {
      display: flex;
    }
  }
  .color-btn {
    display: inline-block;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    background: #d3a143;
    margin-right: 0.5rem;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    justify-content: center;
    svg {
      font-size: 0.75rem;
      color: var(--clr-white);
    }
  }
  .active {
    opacity: 1;
  }
  .btn-container {
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .btn {
    margin-top: 1rem;
    width: 140px;
    background-color: #d3a143;
  }
  .input {
    width: 100%;
    padding: 0.5rem;
    background: var(--clr-grey-10);
    border-radius: var(--radius);
    border-color: transparent;
    letter-spacing: var(--spacing);
  }
  .sort-input {
    max-width: 300px;
    border-color: transparent;
    font-size: 1rem;
    text-transform: uppercase;
    padding: 0.25rem 0.5rem;
    option {
      text-transform: uppercase;
    }
  }

  .input {
    display: flex;
    flex-wrap: wrap;
  }

  .card {
    display: flex;
    border: 1px solid #ccc;
    padding: 10px;
    cursor: pointer;
  }

  .card:hover {
    background-color: #f0f0f0;
  }

  .selected {
    background-color: black;
    color: white;
  }

  .card-content {
    margin: 0;
  }

  .card input[type='radio'] {
    display: none;
  }

  .accordian10 {
    display: flex;
    justify-content: space-around;
  }

  .FlexContainer {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .FlexContainer2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .Offline-stores-link {
    color: black;
    font-style: Roboto;
    text-transform: uppercase;
    font-weight: bold;
    transition: color 0.3s ease;
  }

  .Offline-stores-link:hover {
    color: Purple;
    animation: fadeIn 0.5s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .btn-container-div {
    display: flex;
    justify-content: space-between;
  }

  .store-container {
    margin-top: 40px;
    width: 250px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .spl-btn {
    width: 100% !important;
  }

  .washCareAccordian {
    color: white;
    background-color: black;
    border-radius: 5px;
  }

  .mainColors {
    display: flex;
  }

  @media (max-width: 540px) {
    .mainColors {
      flex-direction: column;
    }
  }

  .blur {
    opacity: 30%;
  }
`;

export default Wrapper;
